import { InfoCircleOutlined } from '@ant-design/icons';
import { Col, Row, Select, Switch, Tooltip } from 'antd';
import React from 'react';
import { NumberInput } from '../../NumberInput';

interface SettingsRowProps {
  label: string;
  value: string | number | boolean;
  type: "select" | "number" | "switch";
  options?: Array<{ label: string; value: string | number }>;
  min?: number;
  max?: number;
  tooltip?: string;
  onChange: (value: string | number | boolean) => void;
}

const SettingsRow: React.FC<SettingsRowProps> = ({
  label,
  value,
  type,
  options,
  min,
  max,
  tooltip,
  onChange,
}) => {
  return (
    <Row gutter={16} align="middle" style={{ marginBottom: 16 }}>
      <Col span={6}>
        <span>
          {label}
          {tooltip && (
            <Tooltip
              title={tooltip}
              overlayStyle={{ maxWidth: '500px' }}
              overlayInnerStyle={{ whiteSpace: 'pre-line' }}
            >
              <InfoCircleOutlined
                style={{
                  color: '#1890ff',
                  cursor: 'help',
                  fontSize: '0.75em',
                  verticalAlign: 'super',
                  marginLeft: '4px'
                }}
              />
            </Tooltip>
          )}
        </span>
      </Col>
      <Col span={18}>
        {type === "switch" ? (
          <Switch checked={value as boolean} onChange={onChange as (checked: boolean) => void} />
        ) : type === "select" ? (
          <Select
            value={value as string | number}
            onChange={(val) => onChange(val)}
            options={options}
            style={{ width: '100%' }}
          />
        ) : (
          <NumberInput
            value={typeof value === 'boolean' ? undefined : value}
            onChange={(val) => {
              // Handle undefined (empty input) - convert to 0 or min
              if (val === undefined) {
                onChange(min !== undefined ? min : 0);
              } else {
                onChange(val);
              }
            }}
            min={min}
            max={max}
            returnNumber={true}
            style={{ width: '100%' }}
          />
        )}
      </Col>
    </Row>
  );
};

export default SettingsRow;
